import axios from "axios";
import { BASE_API_URL } from "@/appConstants";
import loader from "@/plugins/loader.plugin";
import i18n from "@/i18n";

import { generateUniqueItemId, formatPrice, getItemPrice } from "@/utils/itemHelper";
import Vue from "vue";

const lastOrderIdKey = 'sm_last_order_id';
export default {
    namespaced: true,
    state: () => {
        return {
            cart: [],
            orders: [],
            history: [],
            selectedOrderID: undefined,
            clientPhone: '',
            resultProcessing: false,
            deliveryMethod: null,
            paymentMethod: '',
        };
    },
    mutations: {
        ADD_TO_CART(state, item) {
            const isIdentical = (newItem, oldItem) => {
                if (newItem.uid !== oldItem.uid) {
                    return false;
                }

                const sortedNew = [...newItem.subproducts].sort(
                    (a, b) => a.id - b.id
                );
                const sortedOld = [...oldItem.subproducts].sort(
                    (a, b) => a.id - b.id
                );

                for (let i = 0; i < sortedNew.length; i++) {
                    const item1 = sortedNew[i];
                    const item2 = sortedOld[i];

                    if (item1.id !== item2.id || item1.amount !== item2.amount) {
                        return false;
                    }
                }

                return true;
            };

            const uid = generateUniqueItemId(item);
            item.uid = uid;

            let existingMenuItem = (state.cart).find(menuItem => isIdentical(item, menuItem));

            if (existingMenuItem !== undefined) {
                existingMenuItem.count = existingMenuItem.count + item.count;
            } else {
                state.cart.push(item);
            }
        },
        REMOVE_FROM_CART(state, itemUid) {
            if ((state.cart).length) {
                let itemIndex = (state.cart).findIndex(menuItem => menuItem.uid === itemUid);

                if (itemIndex >= 0) {
                    (state.cart).splice(itemIndex, 1);
                }

            } else {
                (state.cart).splice(0);
            }
        },
        REMOVE_ALL_FROM_CART(state) {
            (state.cart).splice(0);
        },
        REMOVE_ALL_FROM_ORDERS(state) {
            (state.orders).splice(0);
        },
        SET_ORDERS_BY_TABLE(state, orders) {
            state.orders = orders;
        },
        SET_HISTORY(state, orders) {
            state.history = orders;
        },
        SET_ORDER_ID(state, orderId) {
            state.selectedOrderID = orderId;
        },
        SET_CLIENT_PHONE(state, phone) {
            state.clientPhone = phone;
        },
        UPDATE_ITEM_QUANTITY(state, { uid, quantity }) {
            let existingMenuItem = (state.cart).find(menuItem => menuItem.uid === uid);

            if (existingMenuItem !== undefined && existingMenuItem.count > 0 && quantity > 0) {
                existingMenuItem.count = quantity;
            }
        },
        SET_DELIVERY_METHOD(state, deliveryMethod) {
            state.deliveryMethod = deliveryMethod;
        },
        SET_PAYMENT_METHOD(state, paymentMethod) {
            state.paymentMethod = paymentMethod;
        },
    },
    actions: {
        SET_ITEM_TO_CART({ rootState }, item) {

            loader.show();

            return axios({
                method: "post",
                url: `${BASE_API_URL}smart-menu/place-order`,
                data: {
                    "locale_id": rootState.companyData.locale.id,
                    "table_id": rootState.tableData.id,
                    "language": i18n.locale,
                    "items": [
                        {
                            "menu_item_id": item.id,
                            "quantity": item.count
                        }
                    ]
                }
            })
                .then(response => {
                    if (response.data.status === "success") {
                        return true;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        return false;
                    }
                })
                .finally(() => loader.hide());
        },
        REMOVE_ITEM_FROM_CART({ commit }, itemUid) {
            commit('REMOVE_FROM_CART', itemUid);
        },
        MAKE_A_PAYMENT({ state, rootGetters, dispatch }, { comment, personalInfo } = {}) {
            loader.show();

            if (rootGetters['getIsModeWMM']) {
                var orderId = state.selectedOrderID;
                if (typeof orderId === 'undefined') {
                    orderId = state.orders[0].id;
                }
                localStorage.setItem(lastOrderIdKey, orderId);
                let mutatedUrl = `${BASE_API_URL}payment/smart-menu/issue/${orderId}?token=${rootGetters['getFingerprint']}`;

                axios({
                    method: "get",
                    url: mutatedUrl
                })
                    .then(response => {
                        if (response.data.status === 'success' && response.data.payment.status.statusCode === 'SUCCESS') {
                            window.location.href = response.data.payment.redirectUri;
                        } else if (response.data.payment.isSubmitForm === true) {
                            document.body.innerHTML += response.data.payment.form;
                            document.getElementById("paymentFormSubmit").submit();
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => loader.hide());
            } else {
                let mutatedUrl = `${BASE_API_URL}smart-menu/create-order`,
                    prefLangCode = rootGetters['getPrefLangCode'] ? rootGetters['getPrefLangCode'] : rootGetters['getCompanyData'].language_active;

                axios({
                    method: "post",
                    url: mutatedUrl,
                    data: {
                        "locale_id": rootGetters['getCompanyData'].locale.id,
                        "language": prefLangCode,
                        "table_id": rootGetters['getTableData'] ? rootGetters['getTableData'].id : null,
                        "fingerprint": rootGetters['getFingerprint'],
                        "phone": state.clientPhone,
                        "delivery_method_id": state.deliveryMethod ? state.deliveryMethod.id : null,
                        "payment_method": state.paymentMethod,
                        "comment": comment,
                        "personal_info": personalInfo,
                        "items": state.cart.map(item => {
                            return {
                                "menu_item_id": item.id,
                                "quantity": item.count,
                                "subproducts": item.subproducts.map(subItem => {
                                    return {
                                        "menu_item_id": subItem.id,
                                        "quantity": subItem.quantity
                                    };
                                })
                            };
                        })
                    }
                })
                    .then(response => {
                        let jsonData = {};
                        try {
                            jsonData = JSON.parse(response.data);
                        } catch (error) {
                            console.log(error);
                        }

                        if (response.data.status === 'success' && response.data.payment.status.statusCode === 'SUCCESS') {
                            window.location.href = response.data.payment.redirectUri;
                        } else if (jsonData.show_success === true) {
                            //make redirect to success page
                            window.location.href = window.location.origin + '/result/?instant_update=1&order_id=' + jsonData.order.id;
                        } else if (response.data.payment.isSubmitForm === true) {
                            document.body.innerHTML += response.data.payment.form;
                            document.getElementById("paymentFormSubmit").submit();
                        }

                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.data.message === 'TRY_LATER_OR_ASK_ADMINISTRATOR_MODE_CHANGED') {
                            Vue.$toast.error(i18n.t(`errors.${error.response.data.message}`))
                            dispatch('FETCH_AND_SET_INITIAL_APP_DATA', null, { root: true });
                        }
                    })
                    .finally(() => loader.hide());
            }
        },
        CLEAR_CART({ commit }) {
            commit('REMOVE_ALL_FROM_CART');
        },
        CLEAR_ORDERS({ commit }) {
            commit('REMOVE_ALL_FROM_ORDERS');
        },
        FETCH_AND_SET_ORDERS_BY_TABLE({ commit, rootState }, store) {
            if (store.getters['getIsModeWMM']) {
                axios({
                    method: "get",
                    url: `${BASE_API_URL}smart-menu/get-table-orders/${rootState.tableData.id}`
                }).then(response => {
                    if (response.status === 200) {
                        commit('SET_ORDERS_BY_TABLE', response.data.orders);
                    }
                });
            } else {
                // commit('SET_ORDERS_BY_TABLE', rootState.cartStore.cart)
            }
        },
        FETCH_IF_PAYED_ORDER_CHANGE_STATUS({ state }, order_id = null) {
            if (state.resultProcessing === true) {
                return;
            }
            if (order_id === null) {
                order_id = state.orders[0].id;
            }
            let mutatedUrl = `${BASE_API_URL}payment/smart-menu/verify/${order_id}`;
            state.resultProcessing = true;

            return axios({
                method: "post",
                url: mutatedUrl
            })
                .then(response => {
                    state.resultProcessing = false;
                    return response.data;
                })
                .catch(error => {
                    state.resultProcessing = false;
                    console.log(error);
                });
        },
        FETCH_ORDERS_HISTORY({ commit }, store) {
            loader.show();
            let mutatedUrl = `${BASE_API_URL}smart-menu/get-orders-history/${store.getters['getCompanyData'].locale.id}/${store.getters['getFingerprint']}`;

            axios({
                method: "post",
                url: mutatedUrl,
            })
                .then(response => {
                    if (response.data.status === 'success') {
                        commit('SET_HISTORY', response.data.orders);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => loader.hide());
        },
        SET_ORDER_ID({ commit }, orderId) {
            commit('SET_ORDER_ID', orderId);
        },
        SET_CLIENT_PHONE({ commit }, phone) {
            commit('SET_CLIENT_PHONE', phone);
        },
        UPDATE_ITEM_QUANTITY({ commit }, { uid, quantity }) {
            commit('UPDATE_ITEM_QUANTITY', { uid, quantity });
        },
        FETCH_ORDER_ID_FROM_FINGERPRINT({ rootState }) {
            let fingerprint = rootState.fingerprint_new;
            let mutatedUrl = `${BASE_API_URL}smart-menu/get-order-id-by-fingerprint/${fingerprint}`;

            return axios({
                method: "post",
                url: mutatedUrl
            })
                .then(response => {
                    if (response.data.status === 'success') {
                        return response.data.order_id;
                    } else {
                        throw new Error('Order ID not found'); // Handle error case
                    }
                })
                .catch(error => {
                    console.log(error);
                    throw error;
                });
        },
        SET_DELIVERY_METHOD({ commit }, deliveryMethod) {
            commit('SET_DELIVERY_METHOD', deliveryMethod);
        },
        SET_PAYMENT_METHOD({ commit }, paymentMethod) {
            commit('SET_PAYMENT_METHOD', paymentMethod);
        },
    },
    getters: {
        getCart: state => state.cart,
        getHistory: state => state.history,
        getLastOrderId: () => localStorage.getItem(lastOrderIdKey),
        getCartTotal: (state, getters, rootState, rootGetters) => {
            let total = 0;

            if (!rootGetters['getIsModeWMM']) {
                total += state.cart.reduce((acc, item) => {
                    return acc + getItemPrice(item);
                }, total);
            }

            if (rootGetters['getIsModeHOT'] && state.deliveryMethod && state.deliveryMethod.price) {
                total += parseFloat(state.deliveryMethod.price);
            }

            return total;
        },
        getFormattedCartTotal: (state, getters) => {
            return formatPrice(getters['getCartTotal']);
        },
        getOrders: state => state.orders,
        getDeliveryMethod: state => state.deliveryMethod,
        getPaymentMethod: state => state.paymentMethod,
    }
};
